// Constants
export const DEFAULT_LANGUAGE = 'en';
export const DEFAULT_CATEGORY = 'UTILITY';
export const COMPONENT_TYPES = {
  HEADER: 'HEADER',
  BODY: 'BODY',
  FOOTER: 'FOOTER',
  BUTTONS: 'BUTTONS',
};
export const MEDIA_FORMATS = ['IMAGE', 'VIDEO', 'DOCUMENT'];

const normalizeComponentType = component =>
  (component?.type ?? component?.Type ?? '').toString().toUpperCase();

export const findComponentByType = (template, type) => {
  if (type == null || type === '') {
    return undefined;
  }

  const normalizedType = String(type).toUpperCase();

  return template.components?.find(
    component => normalizeComponentType(component) === normalizedType
  );
};

const isHttpUrl = s => /^https?:\/\//i.test(String(s || '').trim());

/** Sample header https URL from synced template (Meta / Gupshup), for pre-filling sends. */
export const getMediaHeaderSampleUrlFromTemplate = template => {
  const header = findComponentByType(template, COMPONENT_TYPES.HEADER);
  if (!header) return '';
  const ex = header.example || header.Example;
  if (!ex || typeof ex !== 'object') return '';
  const urls = ex.header_url || ex.headerUrl;
  let list = [];
  if (Array.isArray(urls)) {
    list = urls;
  } else if (urls != null) {
    list = [urls];
  }
  return (
    list
      .filter(u => typeof u === 'string')
      .map(u => u.trim())
      .find(isHttpUrl) || ''
  );
};

export const processVariable = str => {
  return str.replace(/{{|}}/g, '');
};

export const allKeysRequired = value => {
  const keys = Object.keys(value);
  return keys.every(key => value[key]);
};

export const replaceTemplateVariables = (templateText, processedParams) => {
  return templateText.replace(/{{([^}]+)}}/g, (match, variable) => {
    const variableKey = processVariable(variable);
    return processedParams.body?.[variableKey] || `{{${variable}}}`;
  });
};

export const buildTemplateParameters = (template, hasMediaHeaderValue) => {
  const allVariables = {};

  const bodyComponent = findComponentByType(template, COMPONENT_TYPES.BODY);
  const headerComponent = findComponentByType(template, COMPONENT_TYPES.HEADER);

  if (bodyComponent?.text) {
    const matchedVariables = bodyComponent.text.match(/{{([^}]+)}}/g);
    if (matchedVariables) {
      allVariables.body = {};
      matchedVariables.forEach(variable => {
        const key = processVariable(variable);
        allVariables.body[key] = '';
      });
    }
  }

  if (hasMediaHeaderValue && headerComponent?.format) {
    if (!allVariables.header) allVariables.header = {};
    allVariables.header.media_url = '';
    allVariables.header.media_type = String(
      headerComponent.format
    ).toLowerCase();
  }

  // Process button variables
  const buttonComponents = (template.components || []).filter(
    component => normalizeComponentType(component) === COMPONENT_TYPES.BUTTONS
  );

  buttonComponents.forEach(buttonComponent => {
    if (buttonComponent.buttons) {
      buttonComponent.buttons.forEach((button, index) => {
        // Handle URL buttons with variables
        if (button.type === 'URL' && button.url && button.url.includes('{{')) {
          const buttonVars = button.url.match(/{{([^}]+)}}/g) || [];
          if (buttonVars.length > 0) {
            if (!allVariables.buttons) allVariables.buttons = [];
            allVariables.buttons[index] = {
              type: 'url',
              parameter: '',
              url: button.url,
              variables: buttonVars.map(v => processVariable(v)),
            };
          }
        }

        // Handle copy code buttons
        if (button.type === 'COPY_CODE') {
          if (!allVariables.buttons) allVariables.buttons = [];
          allVariables.buttons[index] = {
            type: 'copy_code',
            parameter: '',
          };
        }
      });
    }
  });

  return allVariables;
};
